import React, { useEffect } from 'react';
import './substanceType.css'; //
import useDistributionState from './useDistributionState'; //
import OverviewView from './OverviewView'; //
import TypeView from './TypeView'; //
import SubTypeView from './SubTypeView'; //
import { useParams, useNavigate } from 'react-router-dom';

const SubstanceDistributionNavigator = () => {
    const { type: typeFromUrl, subtype: subTypeFromUrl } = useParams();
    const navigate = useNavigate();

    const {
        currentView,
        selectedType, // typeFromUrl
        selectedSubType, // subTypeFromUrl
        selectedTypeData,
        subTypeDataForView,
        selectedProducts,
        synthesisMethods,
        substanceTypes,
        stats,
        rawData,
    } = useDistributionState(typeFromUrl, subTypeFromUrl);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentView, typeFromUrl, subTypeFromUrl]); //

    // Navigation functions updated to use navigate
    const selectType = (typeName) => {
        navigate(`/substance_type/${encodeURIComponent(typeName)}`);
    };

    const navigateToType = (typeName) => {
        navigate(`/substance_type/${encodeURIComponent(typeName)}`);
    };

    const navigateToSubType = (typeName, subTypeName) => {
        navigate(`/substance_type/${encodeURIComponent(typeName)}/${encodeURIComponent(subTypeName)}`);
    };

    const selectSubType = (subTypeName) => {
        if (selectedType) {
            navigate(`/substance_type/${encodeURIComponent(selectedType)}/${encodeURIComponent(subTypeName)}`);
        }
    };

    const goBackToTypes = () => { // From TypeView or SubTypeView back to Overview
        navigate('/substance_type');
    };

    const goBackToSubTypes = () => { // From SubTypeView back to TypeView
        if (selectedType) {
            navigate(`/substance_type/${encodeURIComponent(selectedType)}`);
        }
    };


    const renderCurrentView = () => {
        switch (currentView) {
            case 'type':
                return (
                    <TypeView
                        selectedType={selectedType}
                        subTypeData={subTypeDataForView}
                        stats={stats}
                        rawData={rawData}
                        substanceTypes={substanceTypes}
                        goBackToTypes={goBackToTypes}
                        selectSubType={selectSubType}
                    />
                );
            case 'subtype':
                return (
                    <SubTypeView
                        selectedType={selectedType}
                        selectedSubType={selectedSubType}
                        selectedProducts={selectedProducts}
                        rawData={rawData}
                        goBackToTypes={goBackToTypes}
                        goBackToSubTypes={goBackToSubTypes}
                    />
                );
            case 'overview':
            default:
                return (
                    <OverviewView
                        stats={stats}
                        synthesisMethods={synthesisMethods}
                        substanceTypes={substanceTypes}
                        rawData={rawData}
                        navigateToType={navigateToType}
                        navigateToSubType={navigateToSubType}
                    />
                );
        }
    };

    return (
        <div className="substance-distribution-navigator"> 
            {renderCurrentView()}
        </div>
    );
};

export default SubstanceDistributionNavigator;